module.exports = "../../app/cells/pages/home/fdo_news_cell.rb";